module.exports = __webpack_public_path__ + "static_pc/img/9.c6fc0226.png";